module.exports = __webpack_public_path__ + "img/F_image13.79001efb.jpg";